export const money = (n) =>
  `${Number(n) < 0 ? "-" : ""}$${Math.abs(Number(n) || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const pnlFmt = (n) => {
  const v = Number(n) || 0;
  return `${v > 0 ? "+" : v < 0 ? "-" : ""}$${Math.abs(v).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const pnlColor = (n) =>
  Number(n) > 0 ? "text-[#0ECB81]" : Number(n) < 0 ? "text-[#F6465D]" : "text-[#EAECEF]";

export const priceFmt = (n) =>
  n === null || n === undefined
    ? "—"
    : Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
